
export function headerFixed() {
    const headerUpsideHeight = document.getElementById('headerPC_upside').offsetHeight;
    const headerNav = document.getElementById('headerPC_nav-pc');
    // const headerFavorite = document.getElementById('headerPC_favoriteLink');

    function setProperty() {
        let scrollTop = window.pageYOffset;

        if (
            matchMedia('min-width:1000px') &&
            scrollTop > headerUpsideHeight
        ){
            headerNav.classList.add('fixed');
            // headerFavorite.classList.add('fixed');
        }else {
            headerNav.classList.remove('fixed');
            // headerFavorite.classList.remove('fixed');
        }
    }

    setProperty();

    document.addEventListener('scroll',() => setProperty())
}